import React, { forwardRef, useContext } from 'react'
import { NumberInputContext } from '../NumberInputContext'
import { InputPrimitive } from '../primitives'

export interface Props extends React.HTMLProps<HTMLInputElement> {}

export const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { round, variant, getInputProps, isDisabled } = useContext(NumberInputContext)
  const inputProps = getInputProps({ ref, props })

  return (
    <InputPrimitive.Root
      {...inputProps}
      round={round}
      dark={variant === 'dark'}
      outlineDark={variant === 'outlineDark'}
      disabled={isDisabled}
    />
  )
})
